import { PACKAGES } from '~pricing/lib/constants';
import { FeatureSetMap, SummaryDisplayFeatureList, FeatureTransformerOptions } from '~pricing/lib/summaryPackages';

import DefaultFeatureSetToSummaryFeatures from './defaultSummaryFeatures';
import SummaryFeatureRules from './featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';
import StandardMonthlyFeatureTransformer from './StandardMonthly';

export type SummaryFeatureTransformer = (
  packageFeatures: FeatureSetMap,
  options: FeatureTransformerOptions
) => SummaryDisplayFeatureList;
export type SummaryPackageFeatureTransformers = Partial<Record<keyof typeof PACKAGES, SummaryFeatureTransformer>>;

const DefaultSummaryFeatureTransformer = summaryFeaturesTransformer(
  DefaultFeatureSetToSummaryFeatures,
  SummaryFeatureRules
);

/**
 * A map of package to the feature transformer for that package.
 * This handles the defaults, but an experiment can override a transformer
 * for any one package or multiple
 */
const SummaryFeatureTransformers: SummaryPackageFeatureTransformers = {
  [PACKAGES.StandardMonthly]: StandardMonthlyFeatureTransformer,
  [PACKAGES.AdvantageAnnual]: DefaultSummaryFeatureTransformer,
  [PACKAGES.TeamAdvantage]: DefaultSummaryFeatureTransformer,
  [PACKAGES.TeamPremier]: DefaultSummaryFeatureTransformer,
  [PACKAGES.Enterprise]: DefaultSummaryFeatureTransformer,
  [PACKAGES.PremierAnnual]: DefaultSummaryFeatureTransformer,
};

export default SummaryFeatureTransformers;
